import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
const initialState: any = {
  contactData: null,
  faqCategories: [],
  faqKeywords: [],
  primaryBanners: [],
  fares: [],
  selectedFaq:null
};

export const webSlice = createSlice({
  name: 'webSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateContactData: (state, action) => {
      state.contactData = action.payload;
    },
    updateFaqCategories: (state, action) => {
      state.faqCategories = action.payload;
    },
    updateSelectedFaq: (state, action) => {
      state.selectedFaq = action.payload;
    },
    updateFaqKeywordss: (state, action) => {
      state.faqKeywords = action.payload;
    },
    updatePrimaryBanners: (state, action) => {
      state.primaryBanners = action.payload;
    },
    updateFares: (state, action) => {
      state.fares = action.payload;
    },
  },
});

export const { updateContactData , updateFaqCategories, updateFaqKeywordss, updatePrimaryBanners, updateFares, updateSelectedFaq } = webSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const contactDataState = (state: RootState) => state.web.contactData;
export const faqCategoriesState = (state: RootState) => state.web.faqCategories;
export const faqKeywordsState = (state: RootState) => state.web.faqKeywords;
export const primaryBannersState = (state: RootState) => state.web.primaryBanners;
export const faresState = (state: RootState) => state.web.fares;
export const selectedFaqState = (state: RootState) => state.web.selectedFaq;

export default webSlice.reducer;
